import { ChevronDown } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const ARROWS = 7;

// Teaser in the visitor's language: template heads come from the site's own translations, the rest from the server.
export const noveltyTeaser = (app, t, lang) => {
  const n = app.novelty;
  if (!n) return "";
  const own = lang === "fr" ? null : n.teaser_i18n?.[lang];
  if (!n.parts) return own || n.teaser;
  const p = n.parts;
  const head = p.kind === "minisite" ? (p.trades ? t("novelty.teaserMiniN", { n: p.trades }) : t("novelty.teaserMini")) : t("novelty.teaserApp", { name: app.name });
  const lead = p.lead ? (own || p.lead) : "";
  return lead ? `${head} ${lead}` : head;
};

// Road-works chevrons: orange/red, lit one after another (~1 s), all pointing down to the new item (static if reduced motion).
const Chevrons = ({ testId }) => (
  <div className="novelty-chevrons flex h-5 items-center justify-center gap-1 overflow-hidden" aria-hidden="true" data-testid={testId}>
    {Array.from({ length: ARROWS }, (_, i) => (
      <ChevronDown key={i} className={`h-5 w-5 shrink-0 ${i % 2 ? "text-red-500" : "text-orange-400"}`} strokeWidth={3}
        style={{ animationDelay: `${(i * 1000) / ARROWS}ms` }} />
    ))}
  </div>
);

// « NOUVEAUTÉ » banner for OFFICIAL apps / mini-sites (cards, presentation page, « Dernier ajout »): the glowing stripe +
// chevrons follow `novelty.banner` (launch mode, else the window after the last version); the pré-pub teaser is permanent.
export const NoveltyBanner = ({ app, teaser = false, testId }) => {
  const { t, lang } = useI18n();
  if (!app?.novelty) return null;
  const shown = app.novelty.banner !== false;
  const label = t(app.category === "minisite" ? "novelty.mini" : "novelty.app");
  const raw = teaser && noveltyTeaser(app, t, lang);
  const text = raw && (!shown || raw.replace(/[.\s]+$/, "") !== label.replace(/[.\s]+$/, "")) ? raw : "";  // never repeat the label
  if (!shown && !text) return null;
  return (
    <div className="min-w-0" data-testid={testId}>
      {shown && (
        <>
          <div className="novelty-stripe flex min-w-0 items-center justify-center rounded-lg px-3 py-1.5 text-center">
            <span className="min-w-0 break-words rounded-md bg-black/85 px-2 py-0.5 font-display text-[0.7rem] font-black uppercase tracking-wider text-[var(--gold-bright)] sm:text-xs" data-testid={`${testId}-label`}>
              {label}
            </span>
          </div>
          <Chevrons testId={`${testId}-chevrons`} />
        </>
      )}
      {text && <p className="mt-1 break-words text-sm font-semibold text-[var(--gold-bright)]" data-testid={`${testId}-teaser`}>{text}</p>}
    </div>
  );
};
